// src/features/auth/authSlice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { loginApi } from '../api/LoginApi';
import { ForgotPasswordApi } from '../api/ForgetPasswordAPI';
// Define the initial state
interface AuthState {
  loading: boolean;
  error: string | null;
  // token: string | null;
}

const initialState: AuthState = {
  loading: false,
  error: null,
  // token: null,
};

// Async thunk for login API call
export const login = createAsyncThunk('auth/login', async (credentials: { userEmail: string; password: string }) => {
  // const data = await loginApi(credentials.email, credentials.password,credentials.password  );
  const data = await loginApi(credentials.userEmail, credentials.password);
  localStorage.setItem("token", data.token);
  // return data.token;
  return data;
});


// Async thunk for forget password API call
export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async (credentials: { userEmail: string }, { rejectWithValue }) => {
    try {
      const response = await ForgotPasswordApi(credentials.userEmail);
      return response;
    } catch (error: any) {
      // Return the error in a format that preserves the axios error structure
      return rejectWithValue(error);
    }
  }
);



// Create the auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      // state.token = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        // state.token = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = 'Login failed. Please check your credentials.';
        // });
      })

      // Forget Password
      .addCase(forgetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgetPassword.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(forgetPassword.rejected, (state) => {
        state.loading = false;
        state.error = 'Failed to send reset password email. Please try again.';
      });

  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
